<template>
<v-container>
  <h2>
    担当者へサービスの利用を許可する
  </h2>
  <br>
  <div class="mb-3 body-2">
    担当者のOilMatrixの利用を許可します。<br>
    本メニューはユーザー権限が「管理者」のユーザーのみが利用可能です。
  </div>

    <div class="mt-8 mb-4">
      <v-card  outlined color="teal" class="mx-auto" max-width="90%">
        <v-card-title>
          <v-icon color="white">mdi-phone-forward</v-icon>
          <span class="white--text body-1 font-weight-light">担当者情報の変更について</span>          
        </v-card-title>
        <v-card-text class="body-2 white--text">
         担当者のEメールアドレスの追加・削除・変更がある場合は、お手数ですがジャパン・アナリストまでご連絡ください。
        </v-card-text>
        <v-btn rounded color="body-2 amber darken-1 font-weight-bold"  @click="openInquiry()" class="mx-2 mb-5">
          <v-icon class="mr-2">mdi-comment-question-outline  </v-icon>ご連絡・お問合わせ
        </v-btn>
      </v-card>
    </div>

    <div class="my-8 mb-4">
      <h3>担当者画面への行き方</h3>
      <v-divider></v-divider>
    </div>

    <div class="ml-4 my-4 body-2">
      メニューの「担当者」をクリックすると、担当者画面が開きます。
    </div>
    <div class="ml-4 body-2">
      <img src="/img/man-employee-confirm-01.png" width="70%" class="my-2">
    </div>

    <div class="my-8 mb-4">
      <h3>サービス利用許可設定のしかた</h3>
      <v-divider></v-divider>
    </div>

    <div class="ml-4 my-4 body-2">
      担当者リストから、サービス利用許可する担当者をクリックします。<br>
      対象となるユーザーは権限が<v-chip small color="grey darken-1"><span class="white--text caption">未許可</span></v-chip>になっているユーザーのみです
    </div>
    <div class="ml-4 body-2">
      <img src="/img/man-employee-grant-01.png" width="90%" class="my-2">
    </div>

    <div class="ml-4 my-4 body-2">
      担当者詳細画面が開いたら、画面下部の「分析・診断サービスの利用を許可」ボタンをクリックしてください。
    </div>
    <div class="ml-4 body-2">
      <img src="/img/man-employee-grant-02.png" width="50%" class="my-2">
    </div>

    <div class="ml-4 my-4 body-2">
      お名前とEメールアドレスを確認し、「許可する」ボタンをクリックしてください。<br>
      利用を許可する担当者様のEメールアドレスに登録用の確認コードを送信します。<br>
    </div>
    <div class="ml-4 body-2">
      <img src="/img/man-employee-grant-03.png" width="60%" class="my-2">
    </div>

    <div class="ml-4 my-4 body-2">
      初期パスワードが自動設定されています。<br>
      初回ログイン時、「確認コード」と「初期パスワード」が必要になりますので<br>
      担当者様に分析・診断サービスの利用許可の完了のご連絡と合わせて、初期パスワードをご連絡してください。<br>
    </div>
    <div class="ml-4 body-2">
      <img src="/img/man-employee-grant-04.png" width="60%" class="my-2">
    </div>


    <div class="body-2 mt-8" align="center">
      <v-card outlined class="pa-4" color="amber lighten-4" max-width="600px">
        <div class="body-2 mb-3">
          <v-icon>mdi-information-outline</v-icon>
          担当者画面の各項目の説明は下記マニュアルをご確認ください。
          </div>
        <div align="center">
          <v-btn small class="white--text" color="success" @click="showMan('manEmployeeConfirm')">
            「担当者一覧を確認する」マニュアルを見る
          </v-btn>
        </div>
      </v-card>
    </div>

</v-container>

</template>
<script>
export default {
    data: () => ({
        buttonName: '',
//        inquiry_url: process.env.VUE_APP_INQUIRY_URL,
        inquiry_url: "https://www.japan-analysts.com/contact/",
    }),
    methods: {
      showMan: async function(value) {
        var url = '/UserManual/' + value
        this.$router.push(url)        
      },
      openInquiry() {
          window.open(this.inquiry_url, '_blank')
      },
    }
}
</script>

